import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../utils/colors';
import { Sizes } from '../../utils/sizes';

const PageContainer = styled.section`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, ${Colors.background} 0%, ${Colors.surface} 100%);
  padding: 80px 20px 60px;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 60px 16px 40px;
  }
`;

const Wrapper = styled.div`
  max-width: 820px;
  margin: 0 auto;
  background: rgba(20, 20, 20, 0.6);
  border: 1px solid ${Colors.gold};
  border-radius: 12px;
  padding: 48px 40px;
  color: ${Colors.white};

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    padding: 32px 24px;
  }
`;

const Title = styled.h1`
  color: ${Colors.yellow};
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 28px 0;
  line-height: 1.25;

  @media (max-width: ${Sizes.mediaQueryBreak1}) {
    font-size: 26px;
    margin-bottom: 22px;
  }
`;

const Paragraph = styled.p`
  color: ${Colors.white};
  font-size: 16px;
  line-height: 1.7;
  margin: 0 0 18px 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

const TermoReembolso = () => {
  return (
    <PageContainer>
      <Wrapper>
        <Title>Termo de Reembolso — Produto Digital</Title>

        <Paragraph>
          Ao realizar a compra deste produto digital, o usuário declara estar
          ciente de que o acesso ao conteúdo é liberado imediatamente após a
          confirmação do pagamento, incluindo possibilidade de visualização e
          download do material adquirido.
        </Paragraph>

        <Paragraph>
          Por se tratar de conteúdo digital de consumo imediato, não será
          possível solicitar reembolso após o acesso, visualização ou download
          do produto.
        </Paragraph>

        <Paragraph>
          Ao concluir a compra, o usuário concorda expressamente com estas
          condições.
        </Paragraph>
      </Wrapper>
    </PageContainer>
  );
};

export default TermoReembolso;
